<template>
<div class="clazz_panel after_border" @click="gotoClazz">
  <img class="cover" v-lazy="clazz.cover_url">
  <div class="info">
    <div class="title">{{ clazz.clazz_name }}</div>
    <div class="detail">
      <div style="margin-bottom: 2px;">参与时间：{{ clazz.start_time_format2 }} ～ {{ clazz.end_time_format2 }}</div>
      <!-- <div style="margin-bottom: 2px;">报名截止：{{ clazz.enroll_end_time_format2 }}</div> -->
      <div>跑步天数：{{ clazz.run_days }}天 | 每天距离：{{ clazz.day_distance }}公里</div>
    </div>
    <!-- <div class="detail">
      跑步天数：{{ clazz.run_days }}天 | 每天距离：{{ clazz.day_distance }}公里
    </div> -->
    <div class="tags">
      {{ clazz.keywords }}
      <!-- <van-tag v-if="clazz.keywords" plain class="clazz_tag" color="#f5222d" size="medium">{{ clazz.keywords }}</van-tag> -->
    </div>
  </div>
</div>
</template>

<script>
import { Tag } from 'vant'

export default {
  name: 'ClazzPanel',
  components: {
    [Tag.name]: Tag
  },
  props: {
    clazz: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  methods: {
    gotoClazz () {
      this.$router.push('/clazz/' + this.clazz.uuid)
    }
  }
}
</script>

<style scoped lang="scss">
.clazz_panel {
  height: 750px;
  height: 145px;
  padding: 25px 0;
  display: flex;
  .cover {
    width: 220px;
    height: 145px;
    margin-left: 20px;
    object-fit: cover;
  }
  .info {
    // display: flex;
    // flex-direction: column;
    // justify-content: space-around;
    height: 145px;
    margin-left: 20px;
    width: 480px;
    .title {
      font-size: 26px;
      font-weight: bold;
      color: #323233;
    }
    .detail {
      font-size: 22px;
      color: #bbb;
      margin-top: 8px;
    }
    .clazz_tag {
      margin-right: 15px;
      border-radius: 10px;
    }
    .tags {
      // min-height: 55px;
      color: #f5222d;
      font-size: 24px;
      line-height: 2;
    }
  }
}
</style>
